export default __webpack_public_path__ + "static/media/kawanLama.cce8157b.png";